import { render, staticRenderFns } from "./searchScholarList.vue?vue&type=template&id=acdab548&scoped=true"
import script from "./searchScholarList.vue?vue&type=script&lang=js"
export * from "./searchScholarList.vue?vue&type=script&lang=js"
import style0 from "./searchScholarList.vue?vue&type=style&index=0&id=acdab548&scoped=true&lang=less"
import style1 from "./searchScholarList.vue?vue&type=style&index=1&id=acdab548&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdab548",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acdab548')) {
      api.createRecord('acdab548', component.options)
    } else {
      api.reload('acdab548', component.options)
    }
    module.hot.accept("./searchScholarList.vue?vue&type=template&id=acdab548&scoped=true", function () {
      api.rerender('acdab548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarSearchGuoJiao/comps/searchScholarList.vue"
export default component.exports